var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5417 2.8584C18.6875 2.8584 13.9417 7.60418 13.9417 13.4584C13.9417 14.7391 14.1693 15.9687 14.587 17.1075L3.18058 28.5139C2.97429 28.7202 2.8584 29 2.8584 29.2917V34.0417C2.8584 34.6492 3.35089 35.1417 3.9584 35.1417H8.7084C9.31591 35.1417 9.8084 34.6492 9.8084 34.0417V31.9751H11.8751C12.4826 31.9751 12.9751 31.4826 12.9751 30.8751V28.8084H15.0417C15.3335 28.8084 15.6133 28.6925 15.8195 28.4862L20.8926 23.4132C22.0314 23.8308 23.261 24.0584 24.5417 24.0584C30.3959 24.0584 35.1417 19.3126 35.1417 13.4584C35.1417 7.60418 30.3959 2.8584 24.5417 2.8584ZM16.1417 13.4584C16.1417 8.81921 19.9026 5.0584 24.5417 5.0584C29.1809 5.0584 32.9417 8.81921 32.9417 13.4584C32.9417 18.0976 29.1809 21.8584 24.5417 21.8584C23.3071 21.8584 22.1376 21.5928 21.0847 21.1165C20.6676 20.9279 20.1773 21.0172 19.8536 21.3409L14.5861 26.6084H11.8751C11.2676 26.6084 10.7751 27.1009 10.7751 27.7084V29.7751H8.7084C8.10089 29.7751 7.6084 30.2676 7.6084 30.8751V32.9417H5.0584V29.7474L16.6592 18.1466C16.9829 17.8229 17.0723 17.3325 16.8836 16.9154C16.4074 15.8625 16.1417 14.693 16.1417 13.4584ZM28.4862 11.0697C28.9158 10.6401 28.9158 9.94365 28.4862 9.51408C28.0566 9.0845 27.3602 9.0845 26.9306 9.51408L25.3472 11.0974C24.9177 11.527 24.9177 12.2235 25.3472 12.653C25.7768 13.0826 26.4733 13.0826 26.9029 12.653L28.4862 11.0697Z",
    fill: "url(#paint0_linear_696_1984)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_1984",
    x1: 15.5001,
    y1: 3.00024,
    x2: 28.0001,
    y2: 32.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43FF99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.0b296482bb82b1932c47182845a75445.svg";
export { ForwardRef as ReactComponent };